@if (rule === null) {
  <ng-container i18n>Please click on the pencil to the right to create a rule</ng-container>
}
@if (rule !== null) {
  @switch (rule.className) {
    @case ('HasRole') {
      <eas-editor-eligibility-rule-value-has-role
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-role>
    }
    @case ('HasDateUserField') {
      <eas-editor-eligibility-rule-value-has-date-user-field
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-date-user-field>
    }
    @case ('HasDiscreteUserField') {
      <eas-editor-eligibility-rule-value-has-discrete-user-field
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-discrete-user-field>
    }
    @case ('HasStringUserField') {
      <eas-editor-eligibility-rule-value-has-string-user-field
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-string-user-field>
    }
    @case ('HasRelation') {
      <eas-editor-eligibility-rule-value-has-relation
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-relation>
    }
    @case ('HasBookingItem') {
      <eas-editor-eligibility-rule-value-has-booking-item
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-booking-item>
    }
    @case ('HasBookingOption') {
      <eas-editor-eligibility-rule-value-has-booking-option
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-booking-option>
    }
    @case ('HasBookingType') {
      <eas-editor-eligibility-rule-value-has-booking-type
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-booking-type>
    }
    @case ('HasEvent') {
      <eas-editor-eligibility-rule-value-has-event
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-event>
    }
    @case ('HasEventCount') {
      <eas-editor-eligibility-rule-value-has-event-count
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-has-event-count>
    }
    @case ('IsRawOperator') {
      <eas-editor-eligibility-rule-value-is-raw-operator
        [rule]="rule"
        [affirmative]="affirmative"
        >
      </eas-editor-eligibility-rule-value-is-raw-operator>
    }
  }
}
